module.exports = __webpack_public_path__ + "img/performanceReport.e6ba5c76.svg";